/* 🤖 this file was generated by svg-to-ts */
export const matIconSubdirectoryArrowLeft: {
  name: 'subdirectory-arrow-left';
  data: string;
} = {
  name: 'subdirectory-arrow-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m11 9 1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"/></svg>`
};
